'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _affiliates = require('./affiliates.html');

var _affiliates2 = _interopRequireDefault(_affiliates);

var _affiliates3 = require('./affiliates.controller');

var _affiliates4 = _interopRequireDefault(_affiliates3);

require('./affiliates.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var affiliateComponent = {
  restrict: 'E',
  bindings: {},
  template: _affiliates2.default,
  controller: _affiliates4.default,
  controllerAs: 'vm'
};

exports.default = affiliateComponent;


/** WEBPACK FOOTER **
 ** ./client/app/containers/affiliates/affiliates.component.js
 **/